import { TextAndIconColors } from '@types';

import styles from './Loader.module.scss';
import { LoaderColors, LoaderSizes } from './Loader.types';

export const LOADER_ICON_COLOR: Record<LoaderColors, TextAndIconColors> = {
  [LoaderColors.brand]: styles.loaderColors_brand,
  [LoaderColors.dark]: styles.loaderColors_dark,
  [LoaderColors.light]: styles.loaderColors_light,
};

export const LOADER_ICON_COLOR_VARS: Record<LoaderColors, string> = {
  [LoaderColors.brand]: styles.loaderColorVars_brand,
  [LoaderColors.dark]: styles.loaderColorVars_dark,
  [LoaderColors.light]: styles.loaderColorVars_light,
};

export const LOADER_ICON_SIZE: Record<LoaderSizes, number> = {
  [LoaderSizes.xs]: Number(styles.loaderSizes_xs),
  [LoaderSizes.s]: Number(styles.loaderSizes_s),
  [LoaderSizes.m]: Number(styles.loaderSizes_m),
  [LoaderSizes.l]: Number(styles.loaderSizes_l),
};
